import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return 'group flex gap-x-2.5 items-center rounded-lg bg-cyan-300 px-2.5 py-2 text-[12px] font-extrabold text-[#071A2B] shadow-lg shadow-cyan-400/10';
        }
        return 'group flex gap-x-2.5 items-center rounded-lg px-2.5 py-2 text-[12px] font-semibold text-slate-300 transition hover:bg-white/10 hover:text-white';
    }
}

export default ComponentNavSidebarComponent;